<template>
    <tr>
        <td>
            <input-field vMoney :format="decimal" :id="'area' + $vnode.key" placeholder="#,###.##" v-model="area.area"></input-field>
        </td>
        <td>
            <input-field vMoney :format="money" :id="'valor' + $vnode.key" placeholder="#,###.##" v-model="area.valor"></input-field>
        </td>
        <td>
            <input-field vMoney :format="decimal" :id="'valor' + $vnode.key" placeholder="#,###.##" v-model="area.hora_trabajo"></input-field>
        </td>
        <td>
            <button @click="eliminar" class="btn-danger btn--text" type="button"><i class="fa fa-trash"></i></button>
        </td>
    </tr>
</template>

<script>
export default {
    props : {
        value : {
            type : Object,
            required : false,
            default : function () {
                return {
                    area : 0,
                    valor : 0,
                    hora_trabajo : 0
                };
            }
        }
    },
    methods : {
        eliminar : function () {
            this.$emit('eliminar', this.$vnode.key);
        }
    },
    data : function () {
        return {
            area : this.value,
            decimal : decimal,
            money : money
        };
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/sts/TrArea.vue